import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoSrc from '../../assets/aita-logo.png';
import './CatalogAdmin.css';

import {
  createCatalogItem,
  listArticulosSeminuevos,
  listCategories,
  updateCatalogItem,
  deleteCatalogItem,
  toggleCatalogItem,
} from '../../api/catalog';
import { FiEdit2, FiTrash2, FiCheckCircle, FiRotateCcw, FiPlusCircle, FiChevronDown } from 'react-icons/fi';
import Paginacion from '../../components/Paginacion';

// Interés anual de todos los artículos (moto o no): se propone al publicar y sigue siendo editable.
const INTERES_ANUAL_DEFAULT = 37;

// Categoría que se propone según la línea del ERP (solo si ya existe en el catálogo).
const CATEGORIA_POR_LINEA = {
  MO: 'Motocicletas', TC: 'Telefonos', PA: 'Pantallas',
  RE: 'Refrigeradores', AN: 'Comedores', BC: 'Bocinas',
};

// sin = sin foto/precio todavía · pub = visible en el catálogo · vendida = marcada como vendida
const estadoDe = (a) => (!a.id ? 'sin' : a.activo ? 'pub' : 'vendida');

export default function CatalogAdmin() {
  const navigate = useNavigate();
  const role  = localStorage.getItem('role');
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (role !== 'admin' && role !== 'compras') navigate('/');
  }, [role, navigate]);

  // Artículo que se está publicando/editando (null = formulario cerrado)
  const [seleccionado, setSeleccionado] = useState(null);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('General');
  const [categories, setCategories] = useState(['General']);
  const [newCatMode, setNewCatMode] = useState(false);
  const [newCat, setNewCat] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [interes, setInteres] = useState('');
  const [images, setImages] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [msg, setMsg] = useState(null);       // errores del formulario
  const [aviso, setAviso] = useState(null);   // confirmaciones de la página
  const [loading, setLoading] = useState(false);
  const [articulos, setArticulos] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [exportando, setExportando] = useState(false);
  const [fileKey, setFileKey] = useState(0);
  const [menuAbierto, setMenuAbierto] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const POR_PAGINA = 15;

  const cambiarFiltro = (cat) => { setFiltroCategoria(cat); setPaginaActual(1); };

  const VERDE     = [34, 139, 34];
  const VERDE_OSC = [22, 100, 22];
  const PLAZOS    = [52, 78, 104, 130, 156];

  // El interés viene de cada artículo; si algún día falta, se usa el 37% de siempre.
  const calcFinanciamiento = (precio, semanas, interesAnual) => {
    const tasa = (interesAnual !== null && interesAnual !== undefined ? Number(interesAnual) : INTERES_ANUAL_DEFAULT) / 100;
    const total = precio * (1 + tasa * (semanas / 52));
    return { total, abono: total / semanas };
  };

  // Lo que está a la venta hoy (publicado y no vendido)
  const publicados = articulos.filter(a => a.id && a.activo);

  const cargarImagen = (src) =>
    new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload  = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = src.replace(/^http:\/\//, 'https://');
    });

  const exportarPDF = async () => {
    setExportando(true);
    try {
    const doc   = new jsPDF({ orientation: 'portrait', format: 'a4' });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 10;
    const gap    = 5;
    const colW   = (pageW - margin * 2 - gap) / 2;

    const logo = await cargarImagen(logoSrc);

    const mes = new Date().toLocaleDateString('es-MX', { month: 'long', year: 'numeric' }).toUpperCase();

    const dibujarEncabezado = () => {
      doc.setDrawColor(...VERDE);
      doc.setLineWidth(2);
      doc.roundedRect(3, 3, pageW - 6, pageH - 6, 5, 5, 'S');
      if (logo) doc.addImage(logo, 'PNG', margin, 0, 28, 27);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.setTextColor(...VERDE_OSC);
      doc.text('CATÁLOGO AITA', pageW / 2, 10, { align: 'center' });
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.5);
      doc.setTextColor(80, 80, 80);
      doc.text('CONTIGO SIEMPRE · VÍA NÓMINA / CRÉDITO EXPRÉS', pageW / 2, 15, { align: 'center' });
      doc.setFontSize(7.5);
      doc.setTextColor(120);
      doc.text(mes, pageW - margin, 10, { align: 'right' });
      doc.setDrawColor(...VERDE);
      doc.setLineWidth(0.7);
      doc.line(margin, 21, pageW - margin, 21);
    };

    // Portada
    const ahora    = new Date();
    const mesNombre = ahora.toLocaleDateString('es-MX', { month: 'long' }).toUpperCase();
    const anio     = ahora.getFullYear();

    doc.setDrawColor(...VERDE);
    doc.setLineWidth(6);
    doc.roundedRect(6, 6, pageW - 12, pageH - 12, 8, 8, 'S');

    if (logo) doc.addImage(logo, 'PNG', pageW / 2 - 65, 8, 130, 93);

    const recX = margin + 8;
    const recW = pageW - (margin + 8) * 2;
    const recY = 120;
    const recH = 68;
    doc.setFillColor(...VERDE);
    doc.roundedRect(recX, recY, recW, recH, 5, 5, 'F');

    doc.setTextColor(255);
    doc.setFont('helvetica', 'bolditalic');
    doc.setFontSize(17);
    doc.text('CATÁLOGO DE', pageW / 2, recY + 14, { align: 'center' });
    doc.text('SEMINUEVOS', pageW / 2, recY + 26, { align: 'center' });
    doc.text(`${mesNombre}  ${anio}`, pageW / 2, recY + 38, { align: 'center' });
    doc.setFontSize(11);
    doc.text('HASTA AGOTAR EXISTENCIAS', pageW / 2, recY + 61, { align: 'center' });

    doc.addPage();
    dibujarEncabezado();
    let curY = 24;

    const porCategoria = {};
    publicados.forEach(item => {
      const cat = item.category || 'General';
      if (!porCategoria[cat]) porCategoria[cat] = [];
      porCategoria[cat].push(item);
    });

    const categoriasList = categories.filter(c => porCategoria[c]);
    for (let ci = 0; ci < categoriasList.length; ci++) {
      const cat      = categoriasList[ci];
      const productos = porCategoria[cat];

      if (ci > 0) {
        doc.addPage();
        dibujarEncabezado();
        curY = 24;
      }

      doc.setFillColor(...VERDE);
      doc.roundedRect(margin, curY, pageW - margin * 2, 7, 1.5, 1.5, 'F');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.setTextColor(255);
      doc.text(cat.toUpperCase(), margin + 3, curY + 4.8);
      curY += 9;

      for (let i = 0; i < productos.length; i += 2) {
        const par = [productos[i], productos[i + 1]].filter(Boolean);
        const alturaEstimada = 105;

        if (curY + alturaEstimada > pageH - margin) {
          doc.addPage();
          dibujarEncabezado();
          curY = 24;
        }

        const yFila = curY;
        const yFinales = [];

        for (let col = 0; col < par.length; col++) {
          const item   = par[col];
          const x      = margin + col * (colW + gap);
          const precio = Number(item.price ?? 0);
          let iy       = yFila;

          const imgUrl = item.images?.[0];
          if (imgUrl) {
            const img = await cargarImagen(imgUrl);
            if (img) {
              const maxH = 38;
              const maxW = colW;
              const ratio = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight);
              const iw = img.naturalWidth  * ratio;
              const ih = img.naturalHeight * ratio;
              doc.addImage(img, 'JPEG', x + (colW - iw) / 2, iy, iw, ih);
              iy += ih + 2;
            }
          } else {
            iy += 4;
          }

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          doc.setTextColor(30, 30, 30);
          const lineas = doc.splitTextToSize(item.title || '', colW);
          doc.text(lineas, x, iy + 4);
          iy += lineas.length * 4 + 5;

          autoTable(doc, {
            startY: iy,
            tableWidth: colW,
            margin: { left: x, right: pageW - x - colW },
            head: [['Plazo', 'Abono sem.', 'Total']],
            body: [
              ['Precio de lista', '', `$${precio.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`],
              ...PLAZOS.map(s => {
                const { abono, total } = calcFinanciamiento(precio, s, item.interes_anual);
                return [`${s} Sem.`, `$${abono.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, `$${total.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`];
              })
            ],
            styles:     { fontSize: 6.5, cellPadding: 1.5 },
            headStyles: { fillColor: VERDE, textColor: 255, fontStyle: 'bold', fontSize: 6.5 },
            columnStyles: {
              0: { cellWidth: colW * 0.42 },
              1: { cellWidth: colW * 0.29, halign: 'right' },
              2: { cellWidth: colW * 0.29, halign: 'right' },
            },
            theme: 'grid',
          });

          yFinales.push(doc.lastAutoTable.finalY);
        }

        curY = Math.max(...yFinales) + 6;
      }

      curY += 3;
    }

    const nombreMes = new Date().toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });
    doc.save(`catalogo_aita_${nombreMes.replace(/ /g, '_')}.pdf`);
    } finally {
      setExportando(false);
    }
  };

  const fetchArticulos = async () => {
    try {
      setLoadingList(true);
      const [data, cats] = await Promise.all([
        listArticulosSeminuevos({ token }),
        listCategories().catch(() => [])
      ]);
      setArticulos(data || []);
      setPaginaActual(1);
      setCategories(cats?.length ? cats : ['General']);
    } catch (err) {
      setAviso(`Error: ${err?.response?.data?.error || err.message}`);
    } finally {
      setLoadingList(false);
    }
  };

  useEffect(() => { fetchArticulos(); }, []);

  const resetForm = () => {
    setSeleccionado(null);
    setTitle('');
    setCategory('General');
    setNewCatMode(false);
    setNewCat('');
    setDescription('');
    setPrice('');
    setInteres('');
    setImages([]);
    setExistingImages([]);
    setMsg(null);
    setFileKey(k => k + 1);
  };

  // Abre el formulario para publicar (sin foto/precio todavía) o editar un artículo ya publicado.
  const onAbrir = (a) => {
    setMenuAbierto(null);
    setAviso(null);
    setSeleccionado(a);
    setTitle(a.title || a.nombre || '');
    const sugerida = CATEGORIA_POR_LINEA[a.linea];
    setCategory(a.category || (sugerida && categories.includes(sugerida) ? sugerida : 'General'));
    setNewCatMode(false);
    setNewCat('');
    setDescription(a.description || '');
    setPrice(a.price ?? '');
    setInteres(a.interes_anual ?? INTERES_ANUAL_DEFAULT);
    setImages([]);
    setExistingImages(a.images || []);
    setMsg(null);
    setFileKey(k => k + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);

    const totalFotos = existingImages.length + images.length;
    if (!title.trim() || !price || interes === '' || totalFotos === 0) {
      setMsg('Error: título, precio, interés anual y al menos una foto son obligatorios.');
      return;
    }
    if (totalFotos > 6) {
      setMsg('Error: máximo 6 fotos por artículo.');
      return;
    }

    const catToSend = newCatMode ? (newCat.trim() || 'General') : category;

    try {
      setLoading(true);
      if (seleccionado.id) {
        await updateCatalogItem({
          id: seleccionado.id,
          token,
          title,
          category: catToSend,
          description,
          price,
          interesAnual: interes,
          imagesFiles: images,
          existingImages
        });
        setAviso(`Actualizado: ${title}`);
      } else {
        const fd = new FormData();
        fd.append('art_clave', seleccionado.art_clave);
        fd.append('title', title);
        fd.append('category', catToSend);
        fd.append('description', description);
        fd.append('price', price);
        fd.append('interes_anual', interes);
        images.forEach(f => fd.append('images', f));

        await createCatalogItem({ token, formData: fd });
        setAviso(`Publicado en el catálogo: ${title}`);
      }
      resetForm();
      await fetchArticulos();
    } catch (err) {
      const detail = err?.response?.data?.error || err.message;
      setMsg(`Error: ${detail}`);
    } finally {
      setLoading(false);
    }
  };

  // Quita foto y precio: el artículo sigue en Existencias y vuelve a "sin publicar".
  const onQuitar = async (a) => {
    if (!window.confirm('¿Quitar la foto y el precio de este artículo? Dejará de verse en el catálogo.')) return;
    setMenuAbierto(null);
    try {
      await deleteCatalogItem({ id: a.id, token });
      if (seleccionado?.id === a.id) resetForm();
      await fetchArticulos();
    } catch (err) {
      alert(err?.response?.data?.error || err.message);
    }
  };

  // Marcar como vendida (sale del catálogo aunque siga en el almacén) o volver a publicarla.
  const onToggleVendida = async (a) => {
    if (a.activo && !window.confirm('¿Marcar como vendida? Dejará de verse en el catálogo aunque siga en el almacén.')) return;
    setMenuAbierto(null);
    try {
      const { activo } = await toggleCatalogItem({ id: a.id, token });
      setArticulos(prev => prev.map(x => x.id === a.id ? { ...x, activo } : x));
    } catch (err) {
      alert(err?.response?.data?.error || err.message);
    }
  };

  // Cada fila "sin publicar" trae cuántas unidades de esa clave faltan por publicar
  const conteo = {
    sin: articulos.filter(a => !a.id).reduce((suma, a) => suma + a.por_publicar, 0),
    pub: publicados.length,
    vendida: articulos.filter(a => estadoDe(a) === 'vendida').length,
  };
  const hayFichasDeMas = articulos.some(a => a.sobran);

  const q = busqueda.trim().toLowerCase();
  const articulosFiltrados = articulos.filter(a => {
    if (filtroEstado && estadoDe(a) !== filtroEstado) return false;
    if (filtroCategoria && !(a.id && (a.category || 'General') === filtroCategoria)) return false;
    if (q && !`${a.title || ''} ${a.nombre} ${a.art_clave}`.toLowerCase().includes(q)) return false;
    return true;
  });

  const categoriasConArticulos = categories.filter(c =>
    articulos.some(a => a.id && (a.category || 'General') === c)
  );

  return (
    <div className="catalog-admin">

      {/* ── Cabecera de página ── */}
      <div className="ca-page-header">
        <button type="button" className="ca-back-btn" onClick={() => navigate('/menu')}>
          ← Menú
        </button>
        <div>
          <h2 className="ca-page-title">Administrar Catálogo</h2>
          <p className="ca-page-sub">
            Artículos del almacén de Seminuevos. Se publican en el catálogo al agregarles foto y precio;
            al facturarse desaparecen solos.
          </p>
        </div>
      </div>

      {aviso && (
        <p className={aviso.startsWith('Error') ? 'error ca-aviso' : 'success ca-aviso'}>{aviso}</p>
      )}

      {hayFichasDeMas && (
        <p className="ca-alerta">
          Hay artículos con más fichas publicadas que unidades en el almacén (marcados con ⚠). Seguramente se facturó una unidad
          que no se marcó como vendida: quita la ficha que ya no corresponde. Mientras tanto el catálogo público muestra solo
          tantas como unidades hay.
        </p>
      )}

      {/* ── Formulario (solo cuando se elige un artículo) ── */}
      {seleccionado && (
        <div className={`ca-form-card${seleccionado.id ? ' editing' : ''}`}>
          <div className="ca-form-header">
            <span className="ca-form-badge">{seleccionado.id ? 'Editando' : '＋ Publicar en el catálogo'}</span>
            <button type="button" className="ca-cancel-edit" onClick={resetForm}>Cancelar</button>
          </div>
          <p className="ca-articulo-info">
            <strong>{seleccionado.nombre}</strong> · {seleccionado.art_clave} · {seleccionado.existencia} en almacén
            {' · '}
            {seleccionado.id
              ? `unidad ${seleccionado.unidad}`
              : `unidad nueva (faltan ${seleccionado.por_publicar} por publicar)`}
          </p>
          {seleccionado.existencia > 1 && (
            <p className="ca-help">
              Cada ficha es una unidad física con su propia foto y precio. Pon en la descripción lo que la distingue (color, kilometraje…).
            </p>
          )}

          <form onSubmit={onSubmit}>
            {/* Categoría */}
            <label className="ca-label">Categoría *</label>
            {!newCatMode ? (
              <div className="ca-row">
                <select className="ca-select" value={category} onChange={e => setCategory(e.target.value)}>
                  {!categories.includes(category) && <option value={category}>{category}</option>}
                  {categories.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <button type="button" className="btn-new" onClick={() => navigate('/category-order-admin')}>Ordenar</button>
                <button type="button" className="btn-new" onClick={() => setNewCatMode(true)}>+ Nueva</button>
              </div>
            ) : (
              <div className="ca-row">
                <input className="ca-input" type="text" value={newCat} onChange={e => setNewCat(e.target.value)} placeholder="Ej: Camas, Sofás…" />
                <button type="button" className="btn-new" onClick={() => {
                  const val = newCat.trim() || 'General';
                  if (!categories.includes(val)) setCategories(prev => [...prev, val].sort());
                  setCategory(val);
                  setNewCatMode(false);
                }}>Usar</button>
                <button type="button" className="btn-delete" onClick={() => { setNewCatMode(false); setNewCat(''); }}>Cancelar</button>
              </div>
            )}

            {/* Título + Precio en dos columnas */}
            <div className="ca-grid-2">
              <div>
                <label className="ca-label">Título (como lo verá el cliente) *</label>
                <input className="ca-input" type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Nombre del producto" />
              </div>
              <div>
                <label className="ca-label">Precio (MXN) *</label>
                <input className="ca-input" type="number" step="0.01" min="0" value={price} onChange={e => setPrice(e.target.value)} placeholder="0.00" />
              </div>
            </div>

            {/* Descripción */}
            <label className="ca-label">Descripción</label>
            <textarea className="ca-textarea" value={description} onChange={e => setDescription(e.target.value)} rows={3} placeholder="Descripción opcional del producto…" />

            {/* Imágenes + Interés en dos columnas */}
            <div className="ca-grid-2">
              <div>
                <label className="ca-label">Fotos (1–6) *</label>
                {existingImages.length > 0 && (
                  <div className="ca-existing-imgs">
                    {existingImages.map((url, i) => (
                      <div key={i} className="ca-existing-img-wrap">
                        <img src={url} alt={`img-${i}`} className="ca-existing-thumb" />
                        <button
                          type="button"
                          className="ca-remove-img"
                          onClick={() => setExistingImages(prev => prev.filter((_, j) => j !== i))}
                        >✕</button>
                      </div>
                    ))}
                  </div>
                )}
                <input key={`imgs-${fileKey}`} className="ca-input ca-file" type="file" accept="image/*" multiple onChange={e => setImages([...e.target.files])} />
              </div>
              <div>
                <label className="ca-label">Interés anual (%) *</label>
                <input className="ca-input" type="number" step="0.01" min="0" value={interes} onChange={e => setInteres(e.target.value)} placeholder="37" />
                <p className="ca-help">Con el precio y este interés se calcula sola la cotización a plazos que ve el cliente.</p>
              </div>
            </div>

            <button className="btn-submit" disabled={loading}>
              {loading
                ? (seleccionado.id ? 'Actualizando…' : 'Publicando…')
                : (seleccionado.id ? 'Actualizar producto' : 'Publicar en el catálogo')}
            </button>

            {msg && <p className={msg.startsWith('Error') ? 'error' : 'success'}>{msg}</p>}
          </form>
        </div>
      )}

      {/* ── Toolbar de la tabla ── */}
      <div className="ca-table-toolbar">
        <span className="ca-table-title">
          Artículos de Seminuevos{' '}
          <span className="ca-count">{conteo.pub} publicados</span>
          {conteo.sin > 0 && <span className="ca-count ca-count-sin">{conteo.sin} sin publicar</span>}
          {conteo.vendida > 0 && <span className="ca-count ca-count-off">{conteo.vendida} vendidas</span>}
        </span>
        <button
          type="button"
          className="ca-export-btn"
          onClick={exportarPDF}
          disabled={loadingList || publicados.length === 0 || exportando}
        >
          {exportando ? 'Generando…' : 'Exportar PDF'}
        </button>
      </div>

      {/* ── Búsqueda y filtro por estado ── */}
      <div className="ca-filters-row">
        <input
          className="ca-input"
          type="search"
          placeholder="Buscar por nombre o clave…"
          value={busqueda}
          onChange={e => { setBusqueda(e.target.value); setPaginaActual(1); }}
        />
        <select
          className="ca-select"
          value={filtroEstado}
          onChange={e => { setFiltroEstado(e.target.value); setPaginaActual(1); }}
        >
          <option value="">Todos los estados</option>
          <option value="sin">Sin publicar</option>
          <option value="pub">Publicados</option>
          <option value="vendida">Vendidas</option>
        </select>
      </div>

      {/* ── Filtro por categoría ── */}
      {categoriasConArticulos.length > 1 && (
        <div className="ca-filter-pills">
          <button
            className={`ca-pill${filtroCategoria === '' ? ' ca-pill--activa' : ''}`}
            onClick={() => cambiarFiltro('')}
          >
            Todas ({articulos.length})
          </button>
          {categoriasConArticulos.map(c => (
            <button
              key={c}
              className={`ca-pill${filtroCategoria === c ? ' ca-pill--activa' : ''}`}
              onClick={() => cambiarFiltro(c)}
            >
              {c} ({articulos.filter(a => a.id && (a.category || 'General') === c).length})
            </button>
          ))}
        </div>
      )}

      {/* ── Tabla ── */}
      <table>
        <thead>
          <tr>
            <th>Imagen</th>
            <th>Artículo</th>
            <th>Categoría</th>
            <th>Precio</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loadingList ? (
            <tr><td colSpan="6" className="ca-empty">Cargando…</td></tr>
          ) : articulosFiltrados.length === 0 ? (
            <tr><td colSpan="6" className="ca-empty">
              {articulos.length === 0 ? 'No hay artículos con existencia en Seminuevos.' : 'No hay artículos con ese filtro.'}
            </td></tr>
          ) : (
            articulosFiltrados.slice((paginaActual - 1) * POR_PAGINA, paginaActual * POR_PAGINA).map(a => {
              const estado = estadoDe(a);
              // Una clave puede tener varias filas (una por unidad), así que la fila se identifica por su ficha
              const idFila = a.id ? `f${a.id}` : `n${a.art_clave}`;
              return (
                <tr key={idFila} className={[estado === 'vendida' ? 'ca-row-inactiva' : '', menuAbierto === idFila ? 'ca-row-menu-open' : ''].filter(Boolean).join(' ')}>
                  <td>
                    {a.images?.[0]
                      ? <img src={a.images[0]} alt={a.title || a.nombre} />
                      : <div className="ca-no-img">Sin foto</div>}
                  </td>
                  <td className="ca-td-title">
                    {a.title || a.nombre}
                    <span className="ca-td-sub">
                      {a.art_clave}
                      {a.id
                        ? ` · unidad ${a.unidad} de ${a.existencia} en almacén`
                        : ` · faltan ${a.por_publicar} de ${a.existencia} por publicar`}
                    </span>
                    {a.sobran && a.id && (
                      <span className="ca-td-warn">⚠ Hay más fichas que unidades en el almacén</span>
                    )}
                  </td>
                  <td>{a.id ? <span className="ca-badge">{a.category || 'General'}</span> : '—'}</td>
                  <td className="ca-td-price">
                    {a.price !== null ? `$${Number(a.price).toLocaleString('es-MX', { minimumFractionDigits: 2 })}` : '—'}
                  </td>
                  <td>
                    {estado === 'pub' && <span className="ca-badge">Publicado</span>}
                    {estado === 'sin' && <span className="ca-badge ca-badge-sin">Sin publicar</span>}
                    {estado === 'vendida' && <span className="ca-badge ca-badge-vendida">Vendida</span>}
                  </td>
                  <td className="ca-td-actions">
                    <div className="ca-menu-wrap">
                      <button
                        className="ca-menu-btn"
                        onClick={() => setMenuAbierto(menuAbierto === idFila ? null : idFila)}
                      >
                        Acciones <FiChevronDown size={13} />
                      </button>
                      {menuAbierto === idFila && (
                        <div className="ca-menu-dropdown">
                          <button onClick={() => onAbrir(a)}>
                            {a.id
                              ? <><FiEdit2 size={14} /> Editar</>
                              : <><FiPlusCircle size={14} /> Publicar unidad (foto y precio)</>}
                          </button>
                          {a.id && (
                            <button onClick={() => onToggleVendida(a)}>
                              {a.activo
                                ? <><FiCheckCircle size={14} /> Marcar como vendida</>
                                : <><FiRotateCcw size={14} /> Volver a publicar</>}
                            </button>
                          )}
                          {a.id && (
                            <button className="ca-menu-danger" onClick={() => onQuitar(a)}>
                              <FiTrash2 size={14} /> Quitar foto y precio
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      <Paginacion
        paginaActual={paginaActual}
        totalPaginas={Math.ceil(articulosFiltrados.length / POR_PAGINA)}
        onChange={setPaginaActual}
      />

    </div>
  );
}
